var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('Loading'):_c('div',[_c('div',{staticClass:"bookingForms-view-tab"},[_c('BookingFormGeneral',{attrs:{"bookingForm":_vm.bookingForm},on:{"save":_vm.save}})],1),_c('div',{staticClass:"bookingForms-view-tab"},[_c('BookingFormFields',{attrs:{"bookingForm":_vm.bookingForm},on:{"save":_vm.save}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }